import Vuex from "vuex";
import Vue from "vue";
import { users } from "./modules/user";
import { tag } from "./modules/tag";
import { alert } from "./modules/alert";

import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    users,
    tag,
    alert
  },
  plugins: [createPersistedState()]
});
